export default function initMainBanner() {
  if ($('.main-banner').length) {
    $('.main-banner').owlCarousel({
      animateOut: 'fadeOut',
      animateIn: 'fadeIn',
      items: 1,
      margin: 0,
      stagePadding: 0,
      smartSpeed: 450,
      mouseDrag: false,
      pullDrag: false,
      touchDrag: false,
      dots: true,
      nav: true,
      autoplay: true,
      autoplayTimeout: 6000,
      loop: true
    });
  }
  $('.main-banner').find('.owl-prev').attr('role','button');
  $('.main-banner').find('.owl-next').attr('role','button');
}